if (!customElements.get('variant-selection')) {
  class VariantSelection extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        increaseHandler: '.js-increase-quantity',
        decreaseHandler: '.js-decrease-quantity',
        addToCartHandler: '.js-add-to-cart',
        promoHandler: '.js-toggle-promo',
        content: '.popup__content',
        tableInteractive: '.variant-selection__table-interactive',
        variantItem: '.variant-selection__item',

        contentActiveClass: 'popup--active',
        popupItemActiveClass: 'variant-selection__popup-item--active',
        firstVariantItemClass: 'variant-selection__item--first',
        lastVariantItemClass: 'variant-selection__item--last'
      };

      this.increaseHandlers = this.querySelectorAll(this.selectors.increaseHandler);
      this.decreaseHandlers = this.querySelectorAll(this.selectors.decreaseHandler);
      this.promoHandlers = this.querySelectorAll(this.selectors.promoHandler);
      this.addToCartHandlers = this.querySelectorAll(this.selectors.addToCartHandler);

      this.increaseHandlers.forEach((handler) => {
        handler.addEventListener('click', this.increaseQuantity.bind(this));
      });

      this.decreaseHandlers.forEach((handler) => {
        handler.addEventListener('click', this.decreaseQuantity.bind(this));
      });

      this.promoHandlers.forEach((handler) => {
        handler.addEventListener('click', this.togglePromo.bind(this));
      });

      this.addToCartHandlers.forEach((handler) => {
        handler.addEventListener('click', (e) => {
          const target = e.currentTarget;
          const currentQuantity = target.closest(this.selectors.tableInteractive)
            .querySelector('input[type="number"]').value;
          const preOrderValue = target.dataset.preOrder;

          window.handlers['addProduct'](target.dataset.id, +currentQuantity, preOrderValue);
        });
      });

      this.sortItems.bind(this)();
    }

    sortItems() {
      const variantItems = [...this.querySelectorAll(this.selectors.variantItem)];

      variantItems.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);

      const firstElement = variantItems[0];
      const lastElement = variantItems[variantItems.length - 1];

      firstElement.classList.add(this.selectors.firstVariantItemClass);
      lastElement.classList.add(this.selectors.lastVariantItemClass);
    }

    increaseQuantity(e) {
      e.preventDefault();

      const currentInput = this.querySelector(`input[data-id="${e.currentTarget.dataset.id}"]`);

      if (+currentInput.value < currentInput.max) currentInput.value = +currentInput.value + 1;
    }

    decreaseQuantity(e) {
      e.preventDefault();

      const currentInput = this.querySelector(`input[data-id="${e.currentTarget.dataset.id}"]`);

      if (+currentInput.value === 1) return

      currentInput.value = +currentInput.value - 1;
    }

    togglePromo(e) {
      e.preventDefault();

      const popupItem = this.querySelector(`.variant-selection__popup-item[data-id="${e.currentTarget.dataset.id}"]`);
      const content = this.querySelector(this.selectors.content);
      const activePopupItems = this.querySelectorAll(`.${this.selectors.popupItemActiveClass}`);


      activePopupItems.forEach(popup => {
        popup.classList.remove(this.selectors.popupItemActiveClass);
      });

      if (popupItem) {
        content.classList.add(this.selectors.contentActiveClass);
        popupItem.classList.add(this.selectors.popupItemActiveClass);
      } else if (content.classList.contains(this.selectors.contentActiveClass)) {
        content.classList.remove(this.selectors.contentActiveClass);
      }

      window.handlers['toggleOverlay']();
    }
  }

  customElements.define('variant-selection', VariantSelection);
}
